import React from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';

const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

export const TOP_FEATURES_TITLES_CONFIG = [
  {
    title: 'Find pet owners in your local area',
    description: () => (
      <p>
        List your services on the <Link to="/business/features#marketing">Pata Marketplace </Link>
        to promote your solo or group classes online, grow your network of clients, and start scheduling bookings for
        training sessions.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-having-treat.webp`,
    altTag: 'Dog being given a treat',
  },
  {
    title: 'Take online bookings',
    description: () => (
      <p>
        Let clients book your training sessions through the Pata Marketplace. With Pata, pet owners have 24/7 access to
        your schedule on our online booking platform, making bookings easier for them and stress-free for you.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-using-pata-on-laptop.webp`,
    altTag: 'A lady sitting with a cat using the Pata platform',
    action: {
      actionText: 'Book a demo',
      onClick: () => {
        window.location = `https://meetings.hubspot.com/pata/demo`;
      },
      buttonType: 'secondary',
    },
  },
  {
    title: 'Simplify admin for your dog training business',
    description: () => (
      <p>
        Manage training sessions, view client details, and organise your class schedules in one centralised platform,
        cutting your time spent on admin.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-with-letters.webp`,
    altTag: 'A dog holding letters with the Pata logo',
  },
  {
    title: 'Easy-to-use platform',
    description: () => (
      <p>
        Our intuitive dog training platform is designed with simplicity in mind, making it quick to navigate and manage
        your sessions, while Pata’s customer support team is on hand to offer help and answer questions.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-holding-dog-with-laptop.webp`,
    altTag: 'A happy lady holding a dog using the Pata platform',
    action: {
      actionText: 'Join Pata',
      onClick: () => {
        window.location = `${VITE_PARTNERS_BASE_URL}/sign-up`;
      },
      buttonType: 'primary',
    },
  },
  {
    title: 'Minimise no-shows',
    description: () => (
      <p>
        Reduce last-minute cancellations and no-shows by requesting upfront payments and storing card details for later
        fees, all made easy with <Link to="/business/pata-pay"> PataPay</Link>. You can also send automated reminders to
        your clients and fill gaps from waiting lists.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-puppy-covering-face.webp`,
    altTag: "A puppy covering it's eyes because of no-shows",
  },
];
